import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { ChatbotAuthProvider } from "./ChatbotAuthContext";
import { BotIdProvider } from "./BotIdContext";
import Chatbot from "./Chatbot";
import "./WidgetMode.css";

export default function WidgetMode() {
  const { botId: botIdFromPath } = useParams();
  const [searchParams] = useSearchParams();

  // Extract botId from URL path (/:botId) or query param (?bot_id=...)
  const botId = botIdFromPath || searchParams.get('bot_id');

  // Update URL if botId is in path but not in query (for backward compatibility)
  useEffect(() => {
    if (botIdFromPath && !searchParams.get('bot_id')) {
      const newUrl = new URL(window.location);
      newUrl.searchParams.set('bot_id', botIdFromPath);
      window.history.replaceState({}, '', newUrl);
    }
  }, [botIdFromPath, searchParams]);
  // Handle close message to parent window (when embedded in iframe)
  useEffect(() => {
    // Check if we're in an iframe
    const isInIframe = window.self !== window.top;

    if (isInIframe) {
      // Listen for close requests from parent (if needed)
      const handleMessage = (event) => {
        // Handle message from parent loader
        if (event.data && typeof event.data === 'object') {
          if (event.data.type === 'WETANO_CHAT_OPEN' || event.data.type === 'CHATBOT_OPEN') {
            // Parent re-opened the widget shell — chat stays mounted in embed iframe
            console.log('[WidgetMode] Received open signal from parent');
          }

          if (event.data.type === 'CHATBOT_REQUEST_CLOSE') {
            // Send close confirmation to parent
            window.parent.postMessage({ type: 'CHATBOT_CLOSE' }, '*');
          }
        }
      };

      window.addEventListener('message', handleMessage);

      return () => {
        window.removeEventListener('message', handleMessage);
      };
    }
  }, []);

  // Handle close action
  const handleClose = () => {
    // Notify parent window to close the iframe container
    window.parent.postMessage({ type: 'CHATBOT_CLOSE' }, '*');
  };

  return (
    <BotIdProvider>
      <ChatbotAuthProvider>
        <div className="widget-mode-container">
          <Chatbot onClose={handleClose} embedded />
        </div>
      </ChatbotAuthProvider>
    </BotIdProvider>
  );
}

